import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { Icon } from "../common";

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(() => !localStorage.getItem("sparko_cookie"));
  const close = (v) => { localStorage.setItem("sparko_cookie", v); setVisible(false); };
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.2, 0.8, 0.2, 1] }}
          className="fixed bottom-4 inset-x-4 md:inset-x-auto md:start-6 md:max-w-md z-[70]" data-testid="cookie-banner"
        >
          <div className="glass rounded-2xl p-5 shadow-2xl">
            <div className="flex items-start gap-3">
              <div className="grid place-items-center h-9 w-9 rounded-full bg-blue/10 text-blue shrink-0"><Icon name="Cookie" size={18} /></div>
              <p className="text-sm text-navy/80 leading-relaxed">{t.cookie.text} <Link to="/privacy" className="text-blue underline">Privacy Policy</Link></p>
            </div>
            <div className="mt-4 flex gap-2 justify-end">
              <button onClick={() => close("declined")} data-testid="cookie-decline" className="rounded-full px-4 py-2 text-sm font-medium text-navy/70 hover:bg-navy/5">{t.cookie.decline}</button>
              <button onClick={() => close("accepted")} data-testid="cookie-accept" className="rounded-full bg-blue px-5 py-2 text-sm font-semibold text-white hover:bg-[#0052FF]">{t.cookie.accept}</button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
